<template>
<div class="chapter">
<div class="inner_page">
<div id="d14be04baee4e-d1e270"><span id="page1">
<h2 class="part-number">PART ONE</h2></span></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781780106915_epub_part001.vue?4fad0e8d